import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await fetch(API_ENDPOINTS.FORGOT_PASSWORD, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(
          data.message || "Код восстановления отправлен на вашу почту"
        );
        // Сохраняем email в sessionStorage для доступа на следующей странице
        sessionStorage.setItem('resetPasswordEmail', email);
        // Переходим на страницу ввода кода
        setTimeout(() => {
          navigate("/reset-password", { state: { email } });
        }, 2000);
      } else {
        setError(data.error || "Произошла ошибка при отправке кода");
      }
    } catch (err) {
      setError("Произошла ошибка сети. Попробуйте еще раз.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Восстановление пароля</h2>
        <p className="auth-description">
          Введите ваш email адрес, и мы отправим вам код для восстановления
          пароля
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="Введите ваш email"
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <button
            type="submit"
            disabled={loading || !email}
            className="auth-button"
          >
            {loading ? "Отправляем..." : "Отправить код"}
          </button>
        </form>

        <div className="auth-links">
          <button onClick={() => navigate("/login")} className="link-button">
            Вернуться к входу
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
